import * as helpers from "reducers/helpers";
import authenticationReducers from "./authentication_reducers";
import notificationsReducers from "./notifications_reducers";

const reducer = helpers.reduceReducers(...authenticationReducers, ...notificationsReducers);

export default reducer;
